import React from 'react';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../../jobs-monitor-host.viewmodel';
import { IDeleteAttendeeJobResult, IMeetingsJobDetails } from '../../../../api/jobs.dao';
import './delete-attendee.scss';

const deleteAttendeeJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IMeetingsJobDetails, IDeleteAttendeeJobResult>> = {
    reviewCompletedJobButtonText: 'Ok',
    reviewFailedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IDeleteAttendeeJobResult>) => {
        const firstName = props.result?.firstName ? `${props.result?.firstName} ` : '';
        const lastName = props.result?.lastName ? `${props.result?.lastName} ` : '';
        return (
            <div className='delete-attendee-result-alert'>
                <div>{`Attendee ${firstName}${lastName}has been deleted`}</div>
            </div>
        );
    },
    failedComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IDeleteAttendeeJobResult>) => {
        const firstName = props.result?.firstName ? `${props.result?.firstName} ` : '';
        const lastName = props.result?.lastName ? `${props.result?.lastName} ` : '';
        return <>{`Attendee deletion ${firstName}${lastName}has failed`}</>;
    }
};

export { deleteAttendeeJobProperties };
